import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
import {
  FaWhatsapp,
  FaLinkedin,
  FaGithub,
  FaInstagram,
} from "react-icons/fa";
import { HiArrowUp } from "react-icons/hi";
import "./Footer.css";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behaivor: "smooth" });
  };

  const footerLinks = [
    { name: "Home", to: "home" },
    { name: "About Me", to: "skill" },
    { name: "Projects", to: "project" },
    { name: "Contact", to: "contact" },
  ];

  const socialLinks = [
    {
      icon: <FaWhatsapp />,
      url: "https://wa.me/+6285857321597",
      label: "WhatsApp",
      color: "#25D366",
    },
    {
      icon: <FaLinkedin />,
      url: "https://www.linkedin.com/in/willy-oktodinata-955081290/",
      label: "LinkedIn",
      color: "#0A66C2",
    },
    {
      icon: <FaGithub />,
      url: "https://github.com/WillyOctz",
      label: "GitHub",
      color: "#ffffff",
    },
    {
      icon: <FaInstagram />,
      url: "https://www.instagram.com/willy.z999?igsh=ajczeWRtZGx3NHVn",
      label: "Instagram",
      color: "#E4405F",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <footer className="footer" id="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <motion.div
          className="footer-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Brand Section */}
          <motion.div className="footer-brand" variants={itemVariants}>
            <h3 className="footer-logo gradient-text">Willy Oktodinata</h3>
            {/* Social Links */}
            <div className="footer-social">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={social.label}
                  whileHover={{
                    scale: 1.2,
                    rotate: 5,
                    color: social.color,
                  }}
                  whileTap={{ scale: 0.9 }}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div className="footer-links-section" variants={itemVariants}>
            <h4 className="footer-section-title">Quick Links</h4>
            <ul className="footer-links">
              {footerLinks.map((link, index) => (
                <motion.li
                  key={index}
                  whileHover={{ x: 5 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <Link
                    to={link.to}
                    smooth={true}
                    duration={500}
                    offset={-80}
                    className="footer-link"
                  >
                    <span className="link-arrow">→</span>
                    {link.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            className="footer-contact-section"
            variants={itemVariants}
          >
            <h4 className="footer-section-title">Get In Touch</h4>
            <div className="footer-contact-info">
              <p>
                <strong>Email:</strong>
                <br />
                <a href="mailto:willyokto123@gmail.com">
                  willyokto123@gmail.com
                </a>
              </p>
              <p>
                <strong>Phone:</strong>
                <br />
                <a href="tel:+6285857321597">+62 8585 7321 597</a>
              </p>
            </div>
          </motion.div>
        </motion.div>

        {/* Footer Bottom */}
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <div className="footer-bottom-content">
            <p className="copyright">
              © {new Date().getFullYear()} Willy Oktodinata. Made with{" "}
              <motion.span
                className="heart"
                animate={{
                  scale: [1, 1.2, 1],
                }}
                transition={{
                  duration: 1,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}
              >
                Effort
              </motion.span>{" "}
              in Indonesia.
            </p>
            <div className="footer-divider" />
            <p className="footer-tech">Built with React.js & Framer Motion</p>
          </div>
        </motion.div>

        {/* Scroll to Top Button */}
        <motion.button
          className="scroll-to-top"
          onClick={scrollToTop}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          whileHover={{ scale: 1.1, y: -5 }}
          whileTap={{ scale: 0.9 }}
          transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
          <HiArrowUp />
        </motion.button>
      </div>

      {/* Animated Footer Background */}
      <div className="footer-bg-elements">
        <motion.div
          className="bg-circle circle-1"
          animate={{
            y: [0, -20, 0],
            opacity: [0.3, 0.5, 0.3],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <motion.div
          className="bg-circle circle-2"
          animate={{
            y: [0, -30, 0],
            opacity: [0.2, 0.4, 0.2],
          }}
          transition={{
            duration: 5,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 1,
          }}
        />
      </div>
    </footer>
  );
};

export default Footer;
